import { useCallback, useLayoutEffect, useRef } from 'react';

export const useAutoScrollToBottom = <T extends HTMLElement>(dependency: unknown) => {
    const containerRef = useRef<T | null>(null);

    const scrollToBottom = useCallback(() => {
        if (containerRef.current) {
            containerRef.current.scrollTo({
                top: containerRef.current.scrollHeight,
                behavior: 'smooth',
            });
        }
    }, []);

    useLayoutEffect(() => {
        scrollToBottom();
    }, [dependency, scrollToBottom]);

    return { containerRef, scrollToBottom };
};
